<template>
  <div class="relative border-right z-builder-panel bg-white settings-sidebar">
    <div
      v-show="!mini"
      class="flex w-full"
    >
      <button
        class="border-right !transition-none border-bottom h-[43px] font-[400] hover:bg-[#fff] w-full p-0 text-[#6E747A] bg-[#FCFCFC] flex items-center justify-center gap-[10px] !text-[12px]"
        :class="{'text-dark !font-[600]': page === 'sections'}"
        @click="() => $store.commit('editor/SET_PAGE', 'sections')"
      >
        <svg
          class="ml-[8px]"
          width="14"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.21665 0.208409C7.07758 0.15278 6.92244 0.15278 6.78336 0.208409L0.950031 2.54174C0.728564 2.63033 0.583342 2.84483 0.583342 3.08335C0.583342 3.32188 0.728564 3.53638 0.950031 3.62497L6.78336 5.9583C6.92244 6.01393 7.07758 6.01393 7.21665 5.9583L13.05 3.62497C13.2715 3.53638 13.4167 3.32188 13.4167 3.08335C13.4167 2.84483 13.2715 2.63033 13.05 2.54174L7.21665 0.208409ZM7.00001 4.78842L2.73735 3.08335L7.00001 1.37829L11.2627 3.08335L7.00001 4.78842Z"
            fill="#6E747A"
          />
          <path
            d="M0.625068 5.78339C0.744718 5.48427 1.0842 5.33877 1.38332 5.45842L7.00001 7.7051L12.6167 5.45842C12.9158 5.33877 13.2553 5.48427 13.375 5.78339C13.4946 6.08251 13.3491 6.422 13.05 6.54165L7.21666 8.87498C7.07758 8.93061 6.92244 8.93061 6.78337 8.87498L0.950035 6.54165C0.650911 6.422 0.505419 6.08251 0.625068 5.78339Z"
            fill="#6E747A"
          />
          <path
            d="M0.625068 8.70006C0.744718 8.40093 1.0842 8.25544 1.38332 8.37509L7.00001 10.6218L12.6167 8.37509C12.9158 8.25544 13.2553 8.40093 13.375 8.70006C13.4946 8.99918 13.3491 9.33866 13.05 9.45831L7.21666 11.7916C7.07758 11.8473 6.92244 11.8473 6.78337 11.7916L0.950035 9.45831C0.650911 9.33866 0.505419 8.99918 0.625068 8.70006Z"
            fill="#6E747A"
          />
        </svg>

        Page Structure
      </button>

      <button
        class="h-[43px] !transition-none border-bottom hover:bg-[#fff] font-[400] w-full p-0 text-[#6E747A] bg-[#FCFCFC] flex items-center justify-center gap-[10px] !text-[12px]"
        :class="{'text-dark !font-[600]': page === 'page-settings'}"
        @click="() => $store.commit('editor/SET_PAGE', 'page-settings')"
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.50002 3.79167C5.00425 3.79167 3.79169 5.00423 3.79169 6.5C3.79169 7.99577 5.00425 9.20833 6.50002 9.20833C7.99579 9.20833 9.20835 7.99577 9.20835 6.5C9.20835 5.00423 7.99579 3.79167 6.50002 3.79167ZM4.87502 6.5C4.87502 5.60254 5.60256 4.875 6.50002 4.875C7.39748 4.875 8.12502 5.60254 8.12502 6.5C8.12502 7.39746 7.39748 8.125 6.50002 8.125C5.60256 8.125 4.87502 7.39746 4.87502 6.5Z"
            fill="#6E747A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.49992 0C5.60246 0 4.87492 0.727537 4.87492 1.625V1.90255C4.30399 2.10435 3.78224 2.40926 3.33193 2.79457L3.09051 2.65519C2.31329 2.20646 1.31945 2.47275 0.870721 3.24998C0.42199 4.0272 0.688287 5.02104 1.46551 5.46977L1.7063 5.60879C1.65282 5.89804 1.62492 6.19596 1.62492 6.5C1.62492 6.8064 1.65326 7.10658 1.70754 7.39793L1.46344 7.53565C0.680326 7.97749 0.408174 8.9734 0.857756 9.7521C1.30591 10.5283 2.3 10.7918 3.0738 10.3395L3.32026 10.1954C3.77261 10.5849 4.29764 10.8931 4.8726 11.0966L4.87028 11.3608C4.86238 12.2638 5.59218 13 6.49518 13C7.38707 13 8.11227 12.2811 8.12008 11.3892L8.12262 11.0983C8.69405 10.8966 9.21626 10.5917 9.66695 10.2063L9.8913 10.3371C10.6689 10.7907 11.6671 10.5255 12.1173 9.74591C12.5646 8.9711 12.3015 7.98046 11.5287 7.52972L11.2933 7.39246C11.3469 7.10282 11.3749 6.80448 11.3749 6.5C11.3749 6.19553 11.3469 5.89721 11.2933 5.60757L11.5287 5.4703C12.3015 5.01955 12.5646 4.02892 12.1173 3.25413C11.6671 2.47447 10.6689 2.20937 9.89127 2.66294L9.66697 2.79377C9.21688 2.40883 8.69546 2.10421 8.12492 1.90255V1.625C8.12492 0.727537 7.39739 0 6.49992 0ZM5.95826 1.625C5.95826 1.32585 6.20077 1.08333 6.49992 1.08333C6.79908 1.08333 7.04159 1.32585 7.04159 1.625V2.30319C7.04159 2.55034 7.20889 2.76615 7.44824 2.82776C8.12537 3.00204 8.73012 3.35917 9.2063 3.84439C9.38083 4.02223 9.65415 4.05807 9.86862 3.93124L9.98394 3.86303L9.98675 3.86138L10.4371 3.59873C10.6963 3.44755 11.029 3.53591 11.1791 3.79579C11.3282 4.05405 11.2405 4.38426 10.9829 4.53451L10.5295 4.79894L10.4184 4.85873C10.1955 4.97869 10.0854 5.23705 10.1532 5.48093C10.2433 5.80458 10.2916 6.14621 10.2916 6.5C10.2916 6.85322 10.2434 7.19432 10.1537 7.5175C10.0867 7.75866 10.1936 8.01433 10.4124 8.13593L10.5263 8.19925L10.9829 8.46552C11.2405 8.61576 11.3282 8.94598 11.1791 9.20424C11.029 9.46412 10.6963 9.55249 10.4371 9.40131L9.98394 9.13702C9.97933 9.13432 9.97467 9.1317 9.96998 9.12915L9.84824 9.06289C9.6359 8.94733 9.37269 8.98647 9.20316 9.15881C8.72746 9.6424 8.12387 9.99835 7.44824 10.1722C7.20889 10.2339 7.04159 10.4497 7.04159 10.6968V10.831L7.03678 11.3798C7.03418 11.677 6.79246 11.9166 6.49518 11.9166C6.1942 11.9166 5.95094 11.6713 5.95358 11.3703L5.95826 10.8381V10.6968C5.95826 10.4497 5.79096 10.2339 5.5516 10.1722C4.8699 9.99679 4.26155 9.63599 3.78391 9.14575C3.61023 8.9675 3.33744 8.93053 3.12258 9.05612L2.52708 9.40423C2.27179 9.55347 1.94381 9.46653 1.79595 9.21044C1.64762 8.95352 1.73741 8.62495 1.99578 8.47917L2.59272 8.14237C2.80994 8.01982 2.9154 7.76478 2.84817 7.52461C2.75712 7.19932 2.70826 6.85581 2.70826 6.5C2.70826 6.14782 2.75613 5.80769 2.8454 5.48535C2.91088 5.24891 2.80927 4.99798 2.59772 4.87372L2.47979 4.80444L2.00718 4.53157C1.7481 4.382 1.65934 4.05072 1.80892 3.79164C1.95849 3.53257 2.28977 3.4438 2.54885 3.59338L3.00906 3.85909L3.11584 3.92625C3.33161 4.06197 3.6128 4.02889 3.79118 3.8468C4.26772 3.36036 4.87336 3.00232 5.5516 2.82776C5.79096 2.76615 5.95826 2.55034 5.95826 2.30319V1.625Z"
            fill="#6E747A"
          />
        </svg>

        Page Settings
      </button>
    </div>

    <pin-unpin-bar v-show="!mini">
      <transition
        mode="out-in"
        name="fade"
      >
        <component
          :is="page"
          style="animation-duration: 0.3s"
        />
      </transition>
    </pin-unpin-bar>

    <button
      v-if="!readonly"
      class="absolute z-builder-floating top-1/2 transform -translate-y-1/2 p-0 right-0 translate-x-[100%]"
      @click="minimize"
    >
      <svg
        fill="none"
        height="43"
        viewBox="0 0 11 43"
        width="11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clip-rule="evenodd"
          d="M10.75 32.0957C10.75 33.5195 10.105 34.8667 8.99578 35.7595L1.24255e-05 43L1.01834e-05 28.8415L1.14441e-05 -4.69897e-07L8.63355 5.68551C9.95472 6.55555 10.75 8.0315 10.75 9.61342L10.75 14.1585L10.75 32.0957Z"
          fill="#E2E5EC"
          fill-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Sections from '@builder/components/editor/navigation/Sections'
import SectionSettings from '@builder/components/editor/navigation/SectionSettings'
import GlobalStyles from '@builder/components/editor/navigation/GlobalStyles'
import FontAdvanced from '@builder/components/editor/navigation/FontAdvanced'
import BlogSettings from '@builder/components/editor/navigation/BlogSettings'
import Blocks from '@builder/components/editor/navigation/Blocks'
import PageSettings from './PageSettings'
import BlocksMenu from './BlocksMenu'
import AddRow from './AddRow'
import AddElement from './AddElement'
import Favorites from './Favorites'
import PinUnpinBar from '../components/PinUnpinBar'


export default {
  name: 'EditorToolbar',
  components: {
    PinUnpinBar,
    Favorites,
    AddElement,
    AddRow,
    BlocksMenu,
    PageSettings,
    Blocks,
    GlobalStyles,
    SectionSettings,
    Sections,
    FontAdvanced,
    BlogSettings
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mini: false
    }
  },
  computed: {
    ...mapState({
      page: state => state.editor.page
    })
  },
  watch: {
    mini (val) {
      if (val) {
        document.body.classList.add('sidbear-mini')
      } else {
        document.body.classList.remove('sidbear-mini')
      }
    }
  },
  created () {
    if (this.readonly) {
      this.mini = true
    } else {
      VEvent.listen('minimize', val => {
        this.mini = val
      })
    }
  },
  beforeDestroy () {
    document.body.classList.remove('sidbear-mini')
  },
  methods: {
    minimize () {
      this.mini = !this.mini
    }
  }
}
</script>
